import React, { useState } from 'react';
import classNames from 'classnames';
import { usePostHog } from 'posthog-js/react';
import { ExternalLink, MailerliteSubscribeForm } from '../../../../components';
import { whatsappIcon, instagramIcon } from '../../Primitives/Link/Icons';

const WhatsAppIcon = () => whatsappIcon();
const InstagramIcon = () => instagramIcon();
const EmailIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
    <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.89 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" />
  </svg>
);

/**
 * Stay Updated section component for footer
 * 
 * @component
 * @param {Object} props
 * @param {string?} props.className
 * @param {string?} props.whatsappUrl URL for WhatsApp status
 * @param {string?} props.instagramUrl URL for Instagram
 * @param {string?} props.emailUrl URL for email subscription (deprecated - using inline form)
 * @returns {JSX.Element}
 */
const StayUpdatedSection = props => {
  const { className, whatsappUrl, instagramUrl } = props;
  const posthog = usePostHog();

  const rootClasses = classNames(
    "w-full mx-2 p-4 bg-[var(--colorJudaica)]/10 rounded-lg border border-[var(--marketplaceColor)]",
    className
  );

  const handleSocialClick = (platform, url) => {
    if (posthog) {
      posthog.capture('social_follow_clicked', {
        platform: platform,
        location: 'footer_stay_updated',
        url: url
      });
    }
  };

  return (
    <div className="flex justify-center items-center max-w-[var(--contentMaxWidthPages)] mx-auto ">
    <div className={rootClasses}>

      {/* Main Heading */}
      <div className="text-center mb-8">
        <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4">
          Stay in the Loop
        </h2>
        <p className="text-gray-700 text-lg md:text-xl leading-relaxed max-w-2xl mx-auto mb-8">
          Join to unlock personalized curation based on your taste, save items you love, and never miss pieces perfect for you.
        </p>

        {/* Email Form */}
        <div className="max-w-md mx-auto space-y-4">
          <MailerliteSubscribeForm
            title=""
            description=""
          />
        </div>
      </div>

      {/* Divider */}
      <div className="border-t border-gray-300 my-8"></div>

      {/* Social Links */}
      <div className="text-center">
        <div className="flex justify-center items-center">


          {/* Instagram */}
          <div className="relative flex mb-1 items-center text-center p-4 border-r-1 border-gray-200 cursor-pointer transition-all duration-200 hover:-translate-y-0.5 hover:shadow-lg">
            <InstagramIcon />
            <div className="flex-grow ml-4 text-left">
              <div className="md:text-md text-sm font-normal leading-6 text-gray-900">Follow Us on</div>
              <div className="md:text-md text-sm font-bold leading-6 text-gray-900">Instagram</div>
            </div>
            {instagramUrl && (
              <ExternalLink
                href={instagramUrl}
                className="absolute inset-0 opacity-0 z-10"
                aria-label="Follow on Instagram"
                onClick={() => handleSocialClick('instagram', instagramUrl)}
              />

            )}
          </div>

          {/* WhatsApp Status */}
          <div className="relative flex items-center text-center p-4 cursor-pointer transition-all duration-200 hover:-translate-y-0.5 hover:shadow-lg">
            <div className="flex items-center justify-center mb-1">
              <WhatsAppIcon />
            </div>
            <div className="flex-grow ml-4 text-left">
              <div className="md:text-md text-sm font-normal leading-6 text-gray-900">Follow Our</div>
              <div className="md:text-md text-sm font-bold leading-6 text-gray-900">Whatsapp Status</div>
            </div>
            {whatsappUrl && (
              <ExternalLink
                href={whatsappUrl}
                className="absolute inset-0 opacity-0 z-10"
                aria-label="Follow WhatsApp status"
                onClick={() => handleSocialClick('whatsapp', whatsappUrl)}
              />
            )}
          </div>


        </div>
      </div>
    </div>
    </div>
  );
};

export default StayUpdatedSection; 